//has_auth 進入頁面是否需要權限判斷
import boardRoutes from './modules/board';
import dashboardRoutes from './modules/dashboard';
import organizationRoutes from './modules/organization';
import allianceRoutes from './modules/alliance';
import alertRoutes from './modules/alert';
import taskRoutes from './modules/task';
import actRoutes from './modules/act';
import guidelineRoutes from './modules/guideline';
import broadcastRoutes from './modules/broadcast';
import announcementRoutes from './modules/announcement';
import checklistRoutes from './modules/checklist';
import changeRoutes from './modules/change';
import licenseRoutes from './modules/license';
import trainingRoutes from './modules/training';
import eventRoutes from './modules/event';
import auditRoutes from './modules/audit';
import contractorRoutes from './modules/contractor';
import fileRoutes from './modules/file';
import meetingRoutes from './modules/meeting';
import qrcodeRoutes from './modules/qrcode';
import notificationRoutes from './modules/notification';
import settingRoutes from './modules/setting';
import logRoutes from './modules/log';
import redirectRoutes from './modules/_redirect';
import coreRoutes from './modules/core';

const route = {
  path: '/factory/:factoryId',
  name: 'factory',
  component: () => import('@/views/Factory/Index.vue'),
  props: true,
  meta: {
    middleware: 'auth',
    name: 'factory',
  },
  children: [
    ...boardRoutes,
    ...dashboardRoutes,
    ...organizationRoutes,
    ...allianceRoutes,
    ...alertRoutes,
    ...taskRoutes,
    ...actRoutes,
    ...guidelineRoutes,
    ...broadcastRoutes,
    ...announcementRoutes,
    ...checklistRoutes,
    ...changeRoutes,
    ...licenseRoutes,
    ...trainingRoutes,
    ...eventRoutes,
    ...auditRoutes,
    ...contractorRoutes,
    ...fileRoutes,
    ...meetingRoutes,
    ...qrcodeRoutes,
    ...notificationRoutes,
    ...settingRoutes,
    ...logRoutes,
    ...redirectRoutes,
    ...coreRoutes,
  ],
};

export default route;
